import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Form, { Submit, Cancel, Select, Checkbox } from "../../../components/Form";

import { FlexForm } from "../styles";

import messages from "./messages";
import { IProps } from "./interfaces";

const parseClasses = (classes: IProps["classes"]) => {
    return classes.map(c => ({
        label: c.name,
        value: c._id,
    }));
};

const ClassForm = ({
    onChange,
    classes,
    loading,
    selectedClass,
    selectedClassValidation,
    saveClassId,
    handleChangeSaveClassId,
    submitClass,
    cancelToKey,
}: IProps) => {
    const { formatMessage } = useIntl();
    return (
        <Form disabled={loading}>
            <FlexForm>
                <Select
                    name="class"
                    options={parseClasses(classes)}
                    validation={selectedClassValidation}
                    value={selectedClass}
                    onChange={onChange}
                    label={formatMessage(messages.homeworkClass)}
                    disabled={loading}
                    noDelete
                />
                <Checkbox
                    label={formatMessage(messages.rememberClassId)}
                    checked={saveClassId}
                    onChange={handleChangeSaveClassId}
                    disabled={loading}
                />
                <Submit onClick={submitClass} loading={loading}>
                    <FormattedMessage {...messages.next} />
                </Submit>
                <Cancel onClick={cancelToKey}>
                    <FormattedMessage {...messages.back} />
                </Cancel>
            </FlexForm>
        </Form>
    );
};

export default ClassForm;
